export default "__VITE_ASSET__BVhGm$$l__"